
      var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCardSelectedHover = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 137,
  height: 69,
  viewBox: "0 0 137 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "card-selected-hover_00403a97f4751166__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M129 0a8 8 0 0 1 8 8v44a8 8 0 0 1-8 8H78.568l-5.844 8.03a2 2 0 0 1-3.234 0L63.646 60H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h121Z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M129 0a8 8 0 0 1 8 8v44a8 8 0 0 1-8 8H78.568l-5.844 8.03a2 2 0 0 1-3.234 0L63.646 60H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h121Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M129 0a8 8 0 0 1 8 8v44a8 8 0 0 1-8 8H78.568l-5.844 8.03a2 2 0 0 1-3.234 0L63.646 60H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h121Z",
  fill: "#fff",
  fillOpacity: 0.08
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M137 8h1-1ZM78.568 60v-1h-.509l-.3.411.81.589Zm-5.844 8.03.808.588-.808-.589Zm-3.234 0-.808.588.808-.589ZM63.646 60l.808-.589-.3-.411h-.508v1ZM0 52h-1 1ZM129 0v1a7 7 0 0 1 7 7h2a9 9 0 0 0-9-9v1Zm8 8h-1v44h2V8h-1Zm0 44h-1a7 7 0 0 1-7 7v2a9 9 0 0 0 9-9h-1Zm-8 8v-1H78.568v2H129v-1Zm-50.432 0-.808-.589-5.845 8.03.809.588.808.589 5.845-8.03-.809-.588Zm-5.844 8.03-.809-.59a1 1 0 0 1-1.617 0l-.808.59-.808.588a3 3 0 0 0 4.85 0l-.808-.589Zm-3.234 0 .809-.59-5.845-8.029-.808.589-.809.589 5.845 8.029.808-.589ZM63.646 60v-1H8v2h55.645v-1ZM8 60v-1a7 7 0 0 1-7-7h-2a9 9 0 0 0 9 9v-1Zm-8-8h1V8h-2v44h1ZM0 8h1a7 7 0 0 1 7-7v-2a9 9 0 0 0-9 9h1Zm8-8v1h121v-2H8v1Z",
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#card-selected-hover_00403a97f4751166__a)"
})));

      const __svgRaw = "<svg width=\"137\" height=\"69\" viewBox=\"0 0 137 69\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<mask id=\"path-1-inside-1_9496_8007\" fill=\"white\">\r\n<path d=\"M129 0C133.418 0 137 3.58172 137 8V52C137 56.4183 133.418 60 129 60H78.5684L72.7236 68.0293C71.9249 69.126 70.289 69.1259 69.4902 68.0293L63.6455 60H8C3.58172 60 2.25497e-07 56.4183 0 52V8C0 3.58172 3.58172 0 8 0H129Z\"/>\r\n</mask>\r\n<path d=\"M129 0C133.418 0 137 3.58172 137 8V52C137 56.4183 133.418 60 129 60H78.5684L72.7236 68.0293C71.9249 69.126 70.289 69.1259 69.4902 68.0293L63.6455 60H8C3.58172 60 2.25497e-07 56.4183 0 52V8C0 3.58172 3.58172 0 8 0H129Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M129 0C133.418 0 137 3.58172 137 8V52C137 56.4183 133.418 60 129 60H78.5684L72.7236 68.0293C71.9249 69.126 70.289 69.1259 69.4902 68.0293L63.6455 60H8C3.58172 60 2.25497e-07 56.4183 0 52V8C0 3.58172 3.58172 0 8 0H129Z\" fill=\"white\" fill-opacity=\"0.08\"/>\r\n<path d=\"M137 8H138H137ZM78.5684 60V59H78.0594L77.7599 59.4115L78.5684 60ZM72.7236 68.0293L73.532 68.618L73.5321 68.6178L72.7236 68.0293ZM69.4902 68.0293L68.6817 68.6178L68.6819 68.6181L69.4902 68.0293ZM63.6455 60L64.454 59.4115L64.1545 59H63.6455V60ZM0 52H-1H0ZM129 0V1C132.866 1 136 4.13401 136 8H137H138C138 3.02944 133.971 -1 129 -1V0ZM137 8H136V52H137H138V8H137ZM137 52H136C136 55.866 132.866 59 129 59V60V61C133.971 61 138 56.9706 138 52H137ZM129 60V59H78.5684V60V61H129V60ZM78.5684 60L77.7599 59.4115L71.9151 67.4408L72.7236 68.0293L73.5321 68.6178L79.3768 60.5885L78.5684 60ZM72.7236 68.0293L71.9153 67.4406C71.516 67.9888 70.698 67.9889 70.2985 67.4405L69.4902 68.0293L68.6819 68.6181C69.8801 70.2629 72.3338 70.2632 73.532 68.618L72.7236 68.0293ZM69.4902 68.0293L70.2987 67.4408L64.454 59.4115L63.6455 60L62.837 60.5885L68.6817 68.6178L69.4902 68.0293ZM63.6455 60V59H8V60V61H63.6455V60ZM8 60V59C4.13401 59 1 55.866 1 52H0H-1C-1 56.9706 3.02944 61 8 61V60ZM0 52H1V8H0H-1V52H0ZM0 8H1C1 4.13401 4.13401 1 8 1V0V-1C3.02944 -1 -1 3.02944 -1 8H0ZM8 0V1H129V0V-1H8V0Z\" \r\nfill=\"var(--theme-primary, #810ea9)\" mask=\"url(#path-1-inside-1_9496_8007)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/card-selected-hover.00403a97f47511660b224021a7328355.svg"),
        {
          React: SvgCardSelectedHover,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      